import { render, staticRenderFns } from "./OrderSectionSplitModal.vue?vue&type=template&id=1cec06f6&scoped=true&"
import script from "./OrderSectionSplitModal.vue?vue&type=script&lang=js&"
export * from "./OrderSectionSplitModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSectionSplitModal.vue?vue&type=style&index=0&id=1cec06f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec06f6",
  null
  
)

export default component.exports